import DialogVisible from '@/app-core/mixins/dialog/dialogVisible'
import DialogData from '@/app-core/mixins/dialog/dialogData'
import CustomerAddressModel from '@/app-core/api/models/customer/CustomerAddressModel'
import VMapAutocompleteService from '@/app-theme/components/map/VMapAutocompleteService.vue'
import AddressCommon from '@/app-core/mixins/maps/addressCommon'
import MapsCommon from '@/app-core/mixins/maps/mapsCommon'
import ServiceTypeEnum from '@/app-core/api/enums/ServiceTypeEnum'

export default {
  name      : 'AccountAddEditAddressDialog',
  components: {VMapAutocompleteService},
  mixins    : [DialogVisible, DialogData, MapsCommon, AddressCommon],
  props     : {},
  dataModel : CustomerAddressModel,
  data() {
    return {}
  },
  computed: {
    ServiceTypeEnum() {
      return ServiceTypeEnum
    },
    address: {
      get() {
        return this.model
      },
      set(value) {
        if (this.model) {
          this.model.setData(value)
          this.$forceUpdate()
        }
      }
    }
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        this.clearSelectedAddress()
        this.$nextTick(() => {
          if (this.model.Id) {
            this.selectedLocation = this.selectedStreet = this.selectedCity = this.addressToPlaceObject(this.model)
            this.markerAddress = this.mapCenter = this.getAddressLatLng(this.model)
          } else {
            this.initMapCenter()
          }
        })
      }
    }
  },
  methods: {
    onSaveClick() {
      if (!this.validateForm() || this.isFormSaving) return
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()

      this.saveFromData()
    }
  }
}
